@if (icon()) {
  <div class="forma-banner__icon">
    <icon [name]="icon()" size="large" [ariaHidden]="true"></icon>
  </div>
}
<div class="forma-banner__content">
  @if (title()) {
    <span class="h4 forma-banner__title">{{ title() }}</span>
  }
  @if (text()) {
    <span class="forma-banner__text">{{ text() }}</span>
  }
</div>

@if (buttonLabel()) {
  <forma-button-group class="banner-button-group">
    <button [formaButton]="buttonAppearance()" class="banner-button" (click)="buttonClick.emit()">
      {{ buttonLabel() }}
    </button>
  </forma-button-group>
}
